import jwtDecode from 'jwt-decode';

function getPayload(token) {
	return jwtDecode(token);
}

function getExpireTime(token) {
	return (getPayload(token)).exp;
}

function isExpired(token) {
	const time = Math.floor(Date.now() / 1000);
	const expire = getExpireTime(token);
	return time > expire;
}

const jwt = {
	isExpired,
	getExpireTime,
};

export default jwt;
